
// array of id's for unwanted images 
const imagesToRemove = [
    { id: '5c5VcFshOds' },
    { id: '8lnbXtxFGZw' },
    { id: 'W8Qqn1PmQH0' },
    { id: 'G6G93jtU1vE' },
    { id: 'fgmf2Eyrwm4' },
    { id: 'nDeo4F3Zq28' },
    { id: 'c333d6YEhi0' },
    { id: 'gGbuETcoKjw' },
    { id: 'bV_mp5XqWc4' },
    { id: 'zunGugEsJCE' },
    { id: 'l1AdCsEnjh0' },
    { id: 'vKBdY7e7KFk' },
    { id: 'MYu49bghVAM' },
    { id: 'Ncn1jiEe-Wc' },
    { id: '09AhDCedXF8' },
    { id: 'UyNrNfdKjwg' },
    { id: 'wJHJY7PcDcg'}
];

export default imagesToRemove;